import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import {
  Link, Navigate, useLocation, useNavigate, useParams,
} from 'react-router-dom';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Alert from 'components/new_ui/Alerts/alert';
import Actions from '../../Actions';
import SummaryPlan from '../Widgets/Summary';
import ActivateModal from '../Widgets/ActivateModal';

function formatDate(date) {
  const d = new Date(date);
  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;
  const year = d.getFullYear();

  if (month.length < 2) { month = `0${month}`; }
  if (day.length < 2) { day = `0${day}`; }

  return [year, month, day].join('-');
}

export default function Summary({ enterpriseId }) {
  const [showActivation, setShowActivation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [typeSave, setTypeSave] = useState(null);

  const { state } = useLocation();
  const { planId } = useParams();
  const plan = state?.plan;
  const navigate = useNavigate();

  if (plan === null) {
    return <Navigate to={routes.managers.plans.edit.plan_details(planId)} replace />;
  }

  const onSave = (type) => {
    const values = {
      ...plan.attributes,
      effective_date: formatDate(plan.attributes.effective_date),
    };
    if (type === 'draft') {
      setLoading(true);
      setTypeSave(type);
      Actions.updatePlan(enterpriseId, planId, values, (_resp) => {
        navigate(routes.managers.policy.index);
      });
    } else if (plan.attributes.possible_activate) {
      setShowActivation(true);
    } else {
      Alert({
        title: 'Activation',
        text: `We are unable to activate your plan at the moment. 
        Please ensure that you have an active Platform Plan before proceeding 
        with the activation of a Professional or Executive Plan. 
        To begin, please activate a Platform Plan.`,
        confirmButtonText: 'Close',
      });
    }
  };

  const onActivate = () => {
    const values = {
      ...plan.attributes,
      effective_date: formatDate(plan.attributes.effective_date),
    };
    Actions.updatePlan(enterpriseId, planId, values, (_resp) => {
      Actions.activatePlan(plan.attributes.enterprise_id, planId, (savedPlan) => {
        navigate(
          routes.managers.plans.edit.success(planId),
          {
            state: { plan: savedPlan },
          },
        );
      });
    });
  };

  return (
    <>
      <section>
        <h1 className="mb-3">Summary</h1>

        <p>
          This is the summary of Talent Insurance Policy.
          Review your the details before activating the policy or save for later
          to active it when you’re ready.
        </p>
      </section>

      <SummaryPlan plan={plan} />

      <footer className="d-lg-flex flex-row-reverse">
        <div className="mb-3 mb-lg-0 ms-lg-3">
          <Button
            className="w-100"
            disabled={loading}
            onClick={() => onSave('active')}
          >
            {loading && typeSave === 'active' && <LoadingPlaceholder placement="inline" text=" " />}
            Activate
          </Button>
        </div>

        <div className="mb-3 mb-lg-0 ms-lg-3">
          <Button
            variant="outline-primary"
            className="btn-reverse w-100"
            disabled={loading}
            onClick={() => onSave('draft')}
          >
            {loading && typeSave === 'draft' && <LoadingPlaceholder placement="inline" text=" " />}
            Save as a Quote
          </Button>
        </div>

        <div className="flex-grow-1 d-flex justify-content-between">
          <Link
            to={routes.managers.plans.edit.services(planId)}
            className="btn btn-primary btn-reverse"
            state={{ plan }}
          >
            Previous
          </Link>

          <Link
            to={routes.managers.policy.index}
            className="btn btn-outline-primary"
          >
            Cancel
          </Link>
        </div>
      </footer>

      <ActivateModal
        show={showActivation}
        plan={plan}
        onClose={() => setShowActivation(false)}
        onActivate={onActivate}
      />
    </>
  );
}

Summary.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
